import React from "react";
import { UseFormRegister } from "react-hook-form";

export default function InputNumber({
  placeholder,
  register,
  name,
  value,
  readOnly,
  disabled,
}: {
  placeholder: string;
  register: UseFormRegister<any>;
  name: string;
  value?: number | string;
  readOnly?: boolean;
  disabled?: boolean;
}) {
  return (
    <>
      <input
        type="number"
        placeholder={placeholder}
        // name={name}
        {...register(name)}
        className="text-lg font-bold border-b border-[#D7D7D7] w-full py-3 mb-5"
        value={value}
        readOnly={readOnly}
        disabled={disabled}
      />
    </>
  );
}
